/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'navigation/finish': {
    width: 25,
    height: 30,
    viewBox: '0 0 25 30',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M20.383 4.617C16.03.263 8.971.263 4.617 4.617.263 8.97.263 16.029 4.617 20.383l7.18 7.181a.994.994 0 001.406 0l7.18-7.18c4.354-4.355 4.354-11.413 0-15.767zM3.661 3.66c4.882-4.881 12.796-4.881 17.678 0 4.881 4.882 4.881 12.796 0 17.678l-7.18 7.18c-.917.916-2.401.916-3.317 0l-7.18-7.18c-4.882-4.882-4.882-12.796 0-17.678z" _fill="#E25046"/><path pid="1" d="M19.594 12.5a7.095 7.095 0 11-14.19 0 7.095 7.095 0 0114.19 0z" _fill="#E25046"/>'
  }
})
